const teamData = [
  {
    id: 1,
    name: 'Chenghao Yi',
    imageUrl: '/images/yichenghao.jpg',
    profileUrl: 'https://www.instagram.com/madman8517/',
    description: `
      <p>Chenghao Yi, born in Chenghai, Shantou, Guangdong, started his yo-yo journey in 2008 after being inspired by the TV show "Blazing Teens".
      In 2010, he began learning yo-yo tricks, and by 2012, he was deeply committed to the 2A dual-hand looping style.
      
      He was previously a signed player for Alpha Group Co., Ltd., working in animation and game design. In 2020, he shifted to e-commerce and livestreaming.
      In 2021, he founded Shantou Ant Hon Cultural Technology Co., Ltd., specializing in various fields including app development, mini-program design, educational systems,
      e-commerce operations, custom product development, and social media training.</p>

      <strong>Key Achievements:</strong>
      <ul>
        <li>2015–2019: Five-time National Champion in China Yo-Yo 2A Division</li>
        <li>2018: Champion of the Singapore Asia Yo-Yo Championship 2A Division (China’s first-ever 2A champion)</li>
        <li>2017: 4th place, Iceland World Yo-Yo Championship 2A Division</li>
        <li>2018: 5th place, Shanghai World Yo-Yo Championship 2A Division</li>
      </ul>

      <strong>Media Appearances:</strong>
      <ul>
        <li>Cast member in "Blazing Teens: The Youth Trio"</li>
        <li>2021: Guangdong Satellite TV "Show of Skills"</li>
        <li>2017: Wuhan Douyu Carnival</li>
        <li>2018: Sina News Headline</li>
        <li>2017: Jiajia Cartoon "Accelerate Forward"</li>
        <li>2021: Douyin "Thumbs Up! Talent Show"</li>
        <li>2022: Tianjin Satellite TV "Cross-Era Battle Letter" Weekly Champion</li>
      </ul>
    `,
  },
  {
      id: 2,
      name: 'Pisco Shuntao Ouyang',
      imageUrl: '/images/team/ouyang.jpg',
      profileUrl: 'https://www.instagram.com/pisco_ouyang/',
      description: `
      <p>Ouyang Shuntao, a native of Zhongshan, Guangdong, is a graduate of the Calligraphy Department of Tianjin Academy of Fine Arts. He began practicing yo-yo in 2007 and has extensive stage experience and performance skills. Ouyang specializes in 1A (single-handed string tricks) and 4A (off-string tricks).
    
      His yo-yo performance style is elegant and highly distinctive, creating a strong visual impact. Beyond refining his yo-yo skills, Ouyang actively promotes the sport, mentoring many up-and-coming talents in the community.
    
      In addition to yo-yoing, Ouyang is an exceptional calligraphy instructor. In 2013, he was admitted to the Calligraphy Department of Tianjin Academy of Fine Arts as the top-ranking calligraphy candidate from Guangdong Province (only two spots were available for Guangdong that year). He graduated in 2017 with a bachelor's degree in calligraphy. Skilled in both brush and pen calligraphy, his style is inspired by Tang Dynasty calligrapher Ouyang Xun and incorporates techniques from Wei Bei (Wei Dynasty steles). He adheres to classical traditions, practicing diligently every day to extract the essence of traditional calligraphy.
    
      Whether in yo-yoing or calligraphy, Ouyang's teaching philosophy emphasizes making learning enjoyable. His engaging and accessible teaching methods are deeply loved by his students.</p>
    
      <strong>Key Achievements:</strong>
      <ul>
        <li>3x National Yo-Yo Championship 4A Off-String Champion</li>
        <li>National Yo-Yo Championship Battle Division Champion</li>
        <li>National Yo-Yo Championship 1A Single-Handed String Tricks Third Place</li>
        <li>China VOID 1A Performance Champion</li>
        <li>East China Yo-Yo Open 4A Champion</li>
        <li>South China Yo-Yo Open 1A/4A Double Champion</li>
        <li>Southwest China Yo-Yo Open Y Division/Soloham Double Champion</li>
        <li>Northwest China Yo-Yo Open 1A Division Champion</li>
        <li>C3 10th Anniversary Yo-Yo Open 4A/Y Division/Battle Triple Champion</li>
      </ul>
    `,
  },
  {
      id: 3,
      name: 'Weijie Li',
      imageUrl: '/images/team/weiwei.jpg',
      profileUrl: 'https://www.instagram.com/2aweiwei/',
      description: `
      <p>A native of Wuhua, Meizhou, Guangdong, this team member was introduced to yo-yos in 2015 and formally started practicing 2A dual-hand looping tricks in 2022. Remarkably, within just one year, they secured a championship title in the 2A division.</P>

      <strong>Specialty:</strong> Yo-yoing.  
      <strong>Talents:</strong> Guitar, singing, street dance, and skateboarding.

      <p>He pursued university studies in e-commerce, livestreaming, and short video production. During their academic years, he received first-class and second-class scholarships and served as a league branch secretary for six years, demonstrating exceptional leadership and organizational skills.</p>

      <strong>Key Achievements:</strong>
      <ul>
        <li>2023 South China Yo-Yo Championship Winner</li>
        <li>2023 Baidu Tieba Yo-Yo Contest Runner-up</li>
        <li>2023 Zhuhai Yo-Yo Contest Runner-up</li>
      </ul>
    `,
  },
  {
      id: 4,
      name: 'Quanshuo Zhang',
      imageUrl: '/images/team/zentamago.jpg',
      profileUrl: 'https://www.instagram.com/zentamago_2a5a/',
      description:  `
      <p>A native of Qingdao, Shandong, since 2014, he has been involved in yo-yoing, focusing on the 2A and 5A divisions, and began studying competitive yo-yo rules in 2018.</p>
    
      <p><strong>Key Achievements:</strong></p>
      <ul>
        <li>2019 CYML Northeast Division 2A Champion, 5A Champion</li>
        <li>2020 CYML East China Division 2A Division 5th Place</li>
        <li>2022 CYML National League 5A Division 7th Place</li>
        <li>2023 CYML Northeast Division 2A Champion</li>
        <li>2023 CYML National League 2A Division 7th Place</li>
      </ul>
    
      <p><strong>Judging Experience:</strong></p>
      <ul>
        <li>2018 Henan College Alliance Yo-Yo Open - Judge</li>
        <li>2019 East China College Alliance Yo-Yo Open - Judge</li>
        <li>2019 CYML Southeast Division - Judge</li>
        <li>2020 Sichuan Online Yo-Yo Open - Judge</li>
        <li>2021 Shanxi Yo-Yo Open (CYML North China Division) - Judge</li>
        <li>2023 Baidu Yo-Yo Tieba Online Open - Head Judge</li>
        <li>2023 Heilongjiang Yo-Yo Open - Judge</li>
        <li>2023 "Chengfeng Cup" Zhuhai Yo-Yo Open - Head Judge</li>
      </ul>
    `,
  },
  {
      id: 5,
      name: 'Zelin Chen',
      imageUrl: '/images/team/zelinchen.jpg',
      profileUrl: 'https://www.instagram.com/chen_zelin7/',
      description:  `
      <p>A native of Shantou, Guangdong, this Chinese yo-yo player is also a certified senior barista. He began exploring yo-yos in 2014 and officially started practicing 2A dual-hand looping tricks in 2018.</p>
    
      <p><strong>Key Achievements:</strong></p>
      <ul>
        <li>2021 National Yo-Yo Championship 2A Division 4th Place</li>
        <li>2023 Baidu Tieba Yo-Yo Contest 3rd Place</li>
        <li>2023 South China Yo-Yo Contest 3rd Place</li>
        <li>2023 Heilongjiang Open Yo-Yo Contest Runner-up</li>
        <li>2023 Zhuhai Yo-Yo Challenge Champion</li>
      </ul>
    `,
  },
  {
      id: 6,
      name: 'Koonho Lee',
      imageUrl: '/images/team/koonholee.jpg',
      profileUrl: 'https://www.instagram.com/billy_lee.koonho/',
      description:  `
      <p>A native of Foshan, Guangdong, this yo-yo player holds a master's degree in design and is a toy design enthusiast (available for private commissions). Currently employed at Mattel, he brings a creative edge to the yo-yo community. His journey in competitive yo-yoing began in 2019.</p>
    
      <p><strong>Key Achievements:</strong></p>
      <ul>
        <li>2019 South China Yo-Yo Contest 2A Division 3rd Place</li>
        <li>2019 CYCC Yo-Yo Contest 2A Division 9th Place</li>
      </ul>
    `,
  },
  {
      id: 7,
      name: 'Xiaohao Yang',
      imageUrl: '/images/team/yangxiaohao.jpg',
      profileUrl: 'https://www.instagram.com/bill_xiaohao/',
      description: `
      <p>A native of Zhongshan, Guangdong, this yo-yo player has an impressive academic background with master's degrees in Landscape Design, Spatial Data Science, and Human-Computer Interaction. Currently pursuing a Ph.D., he has been practicing 2A tricks since 2009 and remain passionate about promoting yo-yo culture.</p>

      <p>He is now exploring innovative art experiments that combine yo-yo performance techniques with computer vision technology, pushing the boundaries of yo-yo artistry.</p>

      <p><strong>Key Achievements:</strong></p>
      <ul>
        <li>2015 China Yo-Yo Alliance Champion Challenge 2A Division 3rd Place</li>
      </ul>
    `,
  },
  {
      id: 8,
      name: 'Zirui Qiu',
      imageUrl: '/images/Destiny - Zirui Qiu Signature Yo-Yo/Thank you for supporting Zirui Qiu.jpg',
      profileUrl: 'https://www.instagram.com/pocket_qiu/',
      description: `
      <p><strong>Team Member:</strong> Zirui Qiu / Pocket</p>
      <p><strong>Signature Yo-Yo:</strong> DESTINY</p>

      <p>A native of Nanjing, Jiangsu, Zirui Qiu started yo-yoing in 2011 and has showcased exceptional skills in 1A (single-handed string tricks) and 2A (dual-hand looping tricks). His unique yo-yo style blends technical precision with artistic flair, making every performance a memorable experience.</p>
      
      <p><strong>Key Achievements:</strong></p>
      <ul>
        <li>2013 CNYC Youth Division 7th Place</li>
        <li>2013 CNYC 2A Division 8th Place</li>
        <li>2013 Jiangsu Yo-Yo Open 2A Division Runner-up</li>
        <li>2014 Jiangsu Yo-Yo Open 2A Division Runner-up</li>
        <li>2016 Jiangsu Yo-Yo Open 1A Division Runner-up</li>
        <li>2016 CYCC 1A Division 17th Place</li>
        <li>2017 CYCC 1A Division 17th Place</li>
        <li>2017 CYCC 2A Division 7th Place</li>
        <li>2019 Eastern Canadian Regional Championship Open Division Champion</li>
        <li>2019 Canadian National Championship Open Division Runner-up</li>
      </ul>

      <p><strong>Judging Experience:</strong></p>
      <ul>
        <li>2017 Eastern China Competition</li>
        <li>2021 Southeastern China Competition</li>
        <li>2022 Eastern China Competition</li>
      </ul>
    `,
  },
  {
    id: 9,
    name: 'KABUTACK',
    imageUrl: '/images/team/kabuda.jpg',
    profileUrl: '',
    description: `
    <p>A native of Jixi, Heilongjiang, this team member discovered yo-yos in 2021 through Bilibili and began exploring the sport in late 2021. By 2022, he was fully committed to practicing yo-yos and improving their skills.</p>
  
    <p>Currently, he works as an animal life engineer, dedicating his career to saving animals and ensuring their health and happiness. He is a certified advanced animal physician and livestock farming specialist, driven by a compassionate heart to protect animal welfare.</p>
  
    <p><strong>Key Achievements:</strong></p>
    <ul>
      <li>202* competition placement</li>
    </ul>
  `,
  }
  // ... more members
];

export { teamData };
